import { render, staticRenderFns } from "./BooleanCellRenderer.vue?vue&type=template&id=22a85dc8&"
import script from "./BooleanCellRenderer.vue?vue&type=script&lang=js&"
export * from "./BooleanCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports